export default {
  title: 'Dictionary',
  category: 'Category',
  item: 'Item',
  categoryName: 'Category Name',
  categoryCode: 'Category Code',
  itemCode: 'Item Code',
  itemName: 'Item Name',
  sortOrder: 'Sort Order',
  enabled: 'Enabled',
  biz_order_status: 'Business Order Status',
  cargo_type: 'Cargo Type',
  currency: 'Currency',
  customer_source: 'Customer Source',
  customer_type_biz: 'Customer Type (Business)',
  customer_type_entry: 'Customer Type (Entry)',
  issuing_airline: 'Issuing Airline',
  legal_entity_relation: 'Legal Entity Relation',
  pallet_type: 'Pallet Type',
  product_type: 'Product Type',
  region: 'Region',
  surcharge_type: 'Surcharge Type',
  transport_mode: 'Transport Mode',
  AREA: 'Destination Area',
}
